module.exports = () => {
  return {
    name: {
      label: '磁贴组件名称',
      type: 'input',
      value: '',
    },
    component_type: {
      label: '组件类型',
      type: 'select',
      options: [
        { label: '大图磁贴', value: 16603 },
        { label: '小图磁贴', value: 16602 },
      ],
      value: '',
    },
  };
};
